import React, { useState, useEffect } from "react";
import { Form, Select, Input, DatePicker, Spin } from "antd";
import { pad, RULES_ANTD } from "../../../constants";
import moment from "moment";
import Order from "../../../api/orderApi";
const { Option } = Select;
const ItemRelationship = (props) => {
  //   console.log(props, "item");
  const { index, data, checkActive } = props;

  // console.log(data);
  const [form] = Form.useForm();
  const [groupVaccine, setGroupVaccine] = useState([]);
  const [pathogens, setPathogens] = useState([]);
  const [pathogensSpacial, setPathogenSSpacial] = useState([]);
  // time du kien tiem

  const [nameListPathogen, setNameListPathogen] = useState([]);
  console.log('nameListPathogen', nameListPathogen)
  useEffect(() => {
    getListGroupVaccine();

    return reset();
  }, []);
  const reset = () => {
    form.resetFields([]);
  };
  //handle group vaccine
  const getGroupVaccine = async () => {
    const result = await Order.getVaccineGroup();
    // console.log("group", result);
    setGroupVaccine(result.data);
  };
  const getListGroupVaccine = async () => {
    await Promise.all([getGroupVaccine(), getPathogens()]);
  };
  const handleGroupVaccine = async (v) => {
    form.resetFields(["AMV_pathogen_id"]);
    setPathogens([]);
    if (v) {
      const data = {
        vaccine_type: "normal",
        group_id: v,
      };

      const res = await Order.getVaccines(data);
      setPathogens(res.data);
    }
  };
  // handle  pathogens
  //handle Special vaccine_type start
  const handleNewArray = (arrays, ob_pathogens) => {
    arrays.forEach(item => {
      const d = ob_pathogens.filter((item2, index) => item2.time == item)
      console.log('d', d)
      setNameListPathogen(d)
    })
  }

  // handle ondeselect statrt

  const getPathogens = async () => {
    const data = {
      vaccine_type: "special",
    };
    const res = await Order.getVaccines(data);
    // console.log("res", res);
    setPathogenSSpacial(res.data);
  };
  //handle Special vaccine_type end

  const disabledDateNow = (current) => {
    return moment() < current;
  };
  return (
    <div key={index} className="">
      <div className="row m-0">
        <div className="col-md-3 col-sm-12 pr-0">
          <Form.Item
            label=" Họ tên người tiêm "
            name={`AMV_contact_person_${index}_name`}
            hasFeedback
            rules={RULES_ANTD.contact_person_1_phone_number}
            initialValue={data && data.name ? data.name : ""}
          >
            <Input
              placeholder={`Người tiêm ${index}`}
              style={{ fontSize: 15 }}
            />
          </Form.Item>
        </div>

        <div className="col-md-3 col-sm-12  pr-0">
          <Form.Item
            label="Căn cước công dân"
            name={`AMV_contact_person_${index}_cccd`}
            hasFeedback
            initialValue={data && data.cccd ? data.cccd : ""}
          >
            <Input
              placeholder={`Căn cước công dân ${index}`}
              style={{ fontSize: 15 }}
            />
          </Form.Item>
        </div>

        <div className="col-md-2 col-sm-4 pr-0 pl-2">
          <Form.Item
            name={`AMV_contact_person_${index}_birthday`}
            hasFeedback
            rules={RULES_ANTD.birth_day}
            label="Ngày sinh"
            initialValue={
              data && data.birth_day ? moment.unix(data.birth_day) : null
            }
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              placeholder="Ngày sinh định dạng 25/03/2021 (*)"
              disabledDate={disabledDateNow}
            />
          </Form.Item>
        </div>

        <div className="col-md-2 col-sm-4 pr-0 pl-2">
          <Form.Item
            label="Giới tính "
            name={`AMV_contact_person_${index}_gender`}
            hasFeedback
            rules={RULES_ANTD.contact_relationship}
            initialValue={data && data.gender ? data.gender : null}
          >
            <Select placeholder="Giới tính" allowClear size="middle">
              <Select.Option value="MALE">Nam</Select.Option>
              <Select.Option value="FEMALE">Nữ</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <div className="col-md-2 col-sm-4 pl-2 ">
          <Form.Item
            label="Quan hệ "
            name={`AMV_contact_person_${index}_relationship`}
            hasFeedback
            rules={RULES_ANTD.contact_relationship}
            initialValue={data ? "Bản thân" : null}
          >
            <Select placeholder="Quan hệ" allowClear size="middle">
              <Select.Option value="Bố">Bố </Select.Option>
              <Select.Option value="Mẹ">Mẹ</Select.Option>
              <Select.Option value="Con">Con</Select.Option>
              <Select.Option value="Vợ">Vợ</Select.Option>
              <Select.Option value="Chồng">Chồng</Select.Option>
              <Select.Option value="Bản thân">Bản thân</Select.Option>
            </Select>
          </Form.Item>
        </div>
      </div>
      <div className="row m-0">
        {checkActive ? (
          <div className="col-md-12 col-sm-12">
            <Form.Item
              name={`AMV_pathogen_id_${index}`}
              hasFeedback
              rules={RULES_ANTD.pathogen}
              label="Tên vắc xin"
            >
              <Select
                placeholder="Kháng nguyên"
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                allowClear
                notFoundContent={
                  pathogensSpacial?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {pathogensSpacial &&
                  pathogensSpacial?.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item.id}
                      className={item.name_pathogen}
                    >
                      {item.name_pathogen}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
        ) : (
          <>
            <div className="col-md-6 col-sm-12">
              <Form.Item
                label="Lựa chọn vắc xin tiêm theo nhóm"
                name={`AMV_type_injection_${index}`}
                hasFeedback
                rules={RULES_ANTD.type_injection}
              >
                <Select
                  placeholder="Lựa chọn vắc xin tiêm theo nhóm"
                  showSearch
                  filterOption={(input, option) => {
                    return (
                      option.className
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                  allowClear
                  onChange={handleGroupVaccine}
                  notFoundContent={
                    groupVaccine?.length < 1 ? <Spin size="small" /> : null
                  }
                >
                  {groupVaccine &&
                    groupVaccine?.map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item.id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-md-6 col-sm-12">
              <Form.Item
                name={`AMV_pathogen_id_${index}`}
                hasFeedback
                rules={RULES_ANTD.pathogen}
                label="Tên vắc xin"
              >
                <Select
                  mode="tags"
                  tokenSeparators={[","]}
                  placeholder="Kháng nguyên"
                  showSearch
                  filterOption={(input, option) => {
                    return (
                      option.className
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                  allowClear
                  notFoundContent={
                    pathogens?.length < 1 ? <Spin size="small" /> : null
                  }
                >
                  {pathogens &&
                    pathogens?.map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item.id}
                        className={item.name_pathogen}
                      >
                        {item.name_pathogen}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ItemRelationship;
